const routes = {
  home: '/',
  main: '/main',
  registration: '/register',
  login: '/login',
  dashboard: '/dashboard',
};
export default routes;